/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import { Fragment, PureComponent } from 'react'
import { Theme } from '@themes/theme'

const Color = (theme: Theme) => css`
  position: relative;
  width: inherit;
  height: auto;
  path#패스_3827 {
    fill: ${theme.color.secondaryBg};
  }
  path#패스_9 {
    fill: ${theme.color.themeTxt};
  }
`

export default class PickMessageIco extends PureComponent {
  render() {
    return (
      <Fragment>
        <svg
          id="그룹_3787"
          data-name="그룹 3787"
          xmlns="http://www.w3.org/2000/svg"
          width="78"
          height="78"
          viewBox="0 0 78 78"
          css={Color}
        >
          <path
            id="패스_3827"
            data-name="패스 3827"
            d="M39,0A39,39,0,1,1,0,39,39,39,0,0,1,39,0Z"
            transform="translate(0 0)"
            fill="#175da5"
          />
          <g id="그룹_3786" data-name="그룹 3786" transform="translate(14.043 21.91)">
            <g id="그룹_27" data-name="그룹 27" transform="translate(0 0)">
              <path
                id="패스_9"
                data-name="패스 9"
                d="M49.334,4.127A3.961,3.961,0,0,0,48.1,1.238,3.674,3.674,0,0,0,45.211,0H3.985A3.523,3.523,0,0,0,1.237,1.238,3.961,3.961,0,0,0,0,4.127V31.64a3.682,3.682,0,0,0,1.237,2.889,3.523,3.523,0,0,0,2.748,1.238H45.211A3.674,3.674,0,0,0,48.1,34.529a3.682,3.682,0,0,0,1.237-2.889V4.127M28.858,21.185l.962-.825L43.428,32.4H5.906L19.514,20.36l.825.825a6.238,6.238,0,0,0,4.4,1.651,6.42,6.42,0,0,0,4.123-1.651m2.886-2.614L45.969,5.019V31.09L31.744,18.571M24.6,20.084a3.179,3.179,0,0,1-2.336-.963L4.81,3.368H44.387L27.072,19.121a3.346,3.346,0,0,1-2.474.963M3.228,31.09V5.019L17.452,18.571,3.228,31.09M31.744,7.153A1.215,1.215,0,0,0,30.37,5.778H18.827a1.215,1.215,0,0,0-1.374,1.376,1.215,1.215,0,0,0,1.374,1.376H30.37A1.215,1.215,0,0,0,31.744,7.153Z"
                fill="#eee"
              />
            </g>
          </g>
        </svg>
      </Fragment>
    )
  }
}
